import { List, Avatar, Typography, Spin } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useWidgetData } from '@hooks/useWidgetData';
import type { WidgetDefinition, WidgetRenderProps } from '@/types';
import { fromNow } from '@/utils';

interface Activity {
  id: string;
  user: string;
  text: string;
  time: string;
}

function ActivityFeedWidget({ instance }: WidgetRenderProps) {
  const { data, isLoading } = useWidgetData<Activity[]>(
    instance.id,
    'activity',
    instance.config,
    instance.refreshInterval,
  );
  if (isLoading) return <Spin />;
  return (
    <List
      size="small"
      dataSource={data ?? []}
      style={{ height: '100%', overflow: 'auto' }}
      renderItem={(item) => (
        <List.Item>
          <List.Item.Meta
            avatar={<Avatar icon={<UserOutlined />} />}
            title={
              <Typography.Text>
                {item.user} <Typography.Text type="secondary">{item.text}</Typography.Text>
              </Typography.Text>
            }
            description={fromNow(item.time)}
          />
        </List.Item>
      )}
    />
  );
}

export const activityWidgetDef: WidgetDefinition = {
  type: 'activity',
  name: 'Activity Feed',
  description: 'Recent activity log',
  icon: 'HistoryOutlined',
  category: 'content',
  defaultTitle: 'Activity',
  defaultConfig: {},
  minW: 3,
  minH: 4,
  defaultW: 4,
  defaultH: 8,
  component: ActivityFeedWidget,
  settingsSchema: { fields: [] },
};
